<div class="edit-billing">
  <div>
    <div>{{ 'label.TaxId' | translate }}:</div>
    <div>
      <input
        type="text"
        maxlength="16"
        [ngModel]="customer && customer.idNumber"
        (ngModelChange)="customer && (customer.idNumber = $event)"
      />
      <hr-field-state-marker [field]="field?.idNumber"></hr-field-state-marker>
    </div>
  </div>
  <div>
    <div>{{ 'label.LegalName' | translate }}:</div>
    <div>
      <input
        type="text"
        maxlength="200"
        [ngModel]="customer && customer.legalName"
        (ngModelChange)="customer && (customer.legalName = $event)"
      />
      <hr-field-state-marker [field]="field?.legalName"></hr-field-state-marker>
    </div>
  </div>
  <div>
    <div>{{ 'label.LegalAddress' | translate }}:</div>
    <div>
      <input
        type="text"
        maxlength="300"
        [ngModel]="customer && customer.legalAddress"
        (ngModelChange)="customer && (customer.legalAddress = $event)"
      />
      <hr-field-state-marker
        [field]="field?.legalAddress"
      ></hr-field-state-marker>
    </div>
  </div>
  <div>
    <div>{{ 'label.VatStatus' | translate }}:</div>
    <div>
      <select
        name="vatStatuses"
        [ngModel]="
          customer &&
          customer.accountDetails &&
          customer.accountDetails.vatStatusId
        "
        (ngModelChange)="
          customer &&
            customer.accountDetails &&
            (customer.accountDetails.vatStatusId = $event)
        "
      >
        <option
          *ngFor="let item of vatStatuses"
          [value]="item.value"
          [selected]="item.value == customer?.accountDetails?.vatStatusId"
        >
          {{ item.text }}
        </option>
      </select>
    </div>
  </div>
  <div>
    <div>
      <button (click)="onSaveClick()">{{ 'label.Save' | translate }}</button>
    </div>
    <div>
      <button (click)="onCancelClick()">
        {{ 'label.Cancel' | translate }}
      </button>
    </div>
  </div>
</div>
